// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__JcWUc","unreadBadge":"styles_unreadBadge__1tmkO","modalContent":"styles_modalContent__2fMwI","modal":"styles_modal__1HctC"};